import ConfirmRemoveObject from './ConfirmRemoveObject';

export default ConfirmRemoveObject;
